import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportYieldShekelMarketFetch } from './actions';

export const sagasReportYieldShekelMarket = [
  takeLatest(actionReportYieldShekelMarketFetch.rejected, workerErrorNotifyThunk),
];
